module.exports = __webpack_public_path__ + "media/images/flags/1x1/ltu-3153cbc52843e7a488fef7588fd622e4.svg";